// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3t6gx","content":"styles_content__1SCFL","checkbox":"styles_checkbox__1XM18","checkboxLabel":"styles_checkboxLabel__3db7v"};